import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";


export class WidthRangeFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'widthRange';
        this.name = 'Interval de largeur (mm)';
        this.type = 'widthRange';

        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    filterSortHtml(): string {
        let classes = "fas fa-stack-1x";
        if (FilterGroup.filters.sort.width === 1 || FilterGroup.filters.sort.width === 0) {
            classes += " fa-sort-amount-down-alt";
        } else if (FilterGroup.filters.sort.width === 2) {
            classes += " fa-sort-amount-up-alt";
        }
        return `
            <span class="fa-stack">
                <i class="${classes}" style="line-height: 2em;"></i>
                ${!FilterGroup.filters.sort.width ?
                '<i class="fas fa-ban fa-stack-2x" style="color:Tomato"></i>' : ''
            }
            </span>
        `;
    }

    updateFilterSortHtml(): void {
        let container = document.getElementById('widthRangeSort');
        if (container) {
            container.innerHTML = this.filterSortHtml();
        }
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;align-items: end;justify-content: center;margin:0 auto;max-width: 380px;width: 100%;">
            <div class="col-xs-11" style="display:flex;flex-direction:column;align-items: center;">
                <div style="display:flex;width:calc(100% + 25px);justify-content:space-between;">
                    <div>Min <span id="widthMin">${FilterGroup.getMinWidth()}</span></div>
                    <span>${this.name}</span>
                    <div>Max <span id="widthMax">${FilterGroup.getMaxWidth()}</span></div>
                </div>
                <div id="widthRangeInput" style="width: 100%;"></div>
            </div>
            <div style="cursor: pointer; padding: 0;" class="col-xs-1" id="widthRangeSort">
                ${this.filterSortHtml()}
            </div>
        </div>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            this.controller.addEventListener('click', () => {
                FilterGroup.filters.sort.width = (FilterGroup.filters.sort.width + 1) % 3;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters).then(() => this.updateFilterSortHtml());
            }, 'widthRangeSort');
        }, 50);
        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }
}